"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PERMISSIONS = void 0;
/**
 * Permission codes for DegreePlan feature access.
 *
 * SECURITY NOTE: These constants are client-side UX guards only.
 * The authoritative enforcement boundary is the backend API, which validates
 * the JWT on every request. Never rely solely on client-side checks for security.
 */
exports.PERMISSIONS = {
    /** Required for all DegreePlan users — app-wide access gate */
    DEGREE_PLAN_ACCESS: 'degree-plan-access',
    /** Required for Student Success Coordinators — individual student plan editing */
    DEGREE_PLAN_EDIT: 'degree-plan-edit',
    /** Required for Heads of Student Success — cohort-level work */
    DEGREE_PLAN_COHORT_APPLY: 'degree-plan-cohort-apply',
    /** Required for admin users — user account management */
    USER_MANAGEMENT_ACCESS: 'user-management-access',
};
